import React from 'react';

import { Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    ReactHookFormInput,
    ReactHookFormSelect,
} from 'common/components/form';

const AmountFields = ({ control }) => {
    const { t } = useTranslation();

    const valueType = useWatch({ control, name: 'value_type' });

    return (
        <Grid container>
            <Grid size={{ md: 'grow', xs: 18 }}>
                <ReactHookFormInput
                    append={[1, 2].includes(valueType) ? 'MXN' : '%'}
                    control={control}
                    label={t('Quantity')}
                    name="amount"
                    onlyNumbers={true}
                    prepend={[1, 2].includes(valueType) ? '$' : ''}
                    type="text"
                />
            </Grid>

            <Grid size={{ md: 'grow', xs: 18 }}>
                <ReactHookFormSelect
                    control={control}
                    label={t('Unit')}
                    name="value_type"
                    options={[
                        { label: `$/${t('Fixed')}`, value: 1 },
                        { label: `$/kW ${t('Yearly')}`, value: 2 },
                        { label: `%/${t('Amount to finance')}`, value: 0 },
                        { label: `%/${t('Total system')}`, value: 3 },
                        { label: `%/${t('Subtotal to finance')}`, value: 4 },
                    ]}
                />
            </Grid>
        </Grid>
    );
};

AmountFields.propTypes = {
    control: PropTypes.object,
};

export default AmountFields;
